import styled from 'styled-components';

import Card from '../../Card';


export const StyledCard = styled(Card)`
  h5 {
    text-align: center;
    margin-bottom: 20px;

    span {
      color: #3ee9f7;
    }
  }
`;

export const Lesson = styled.div`
  display: flex;
  padding: 10px 30px;
  background: darkslategray;
  border-radius: 8px;
  margin: 15px 0;
  cursor: pointer;

  &:first-of-type {
    margin-top: 0;
  }

  img {
    max-width: 110px;
    max-height: 110px;
  }
`;

export const LessonInfo = styled.div`
  margin-left: 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  p {
    color: #d7d7d7;
    margin-top: 12px;
    margin-bottom: 0;
  }
`;



// WEBPACK FOOTER //
// ./src/components/DataCentre/LessonSelector/LessonSelector.styles.ts